<template>
  <div class="channel-list-template" theme>
    <div id="theme-channel-list-header" />
    <div id="theme-channel-list-leftside" />
    <div id="theme-channel-list-content" />
    <div id="theme-channel-list-rightside" />
    <div id="theme-channel-list-footer" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'channel-list',
      parts: [
        {
          elem: '#theme-channel-list-header',
          htmlFile: 'header'
        },
        {
          elem: '#theme-channel-list-leftside',
          htmlFile: 'leftside'
        },
        {
          elem: '#theme-channel-list-content',
          htmlFile: 'content'
        },
        {
          elem: '#theme-channel-list-rightside',
          htmlFile: 'rightside'
        },
        {
          elem: '#theme-channel-list-footer',
          htmlFile: 'footer'
        }
      ]
    }
  }
}
</script>

<style scoped>
.channel-list-template {
  min-height: 100px;
  margin-top: -35px;
}
</style>
